export default "__VITE_ASSET__D5z2HY1T__"